import { connect } from 'react-redux';

import { getFooterNavigation } from 'store/reducers/navigation';

import Footer from './Footer';

const mapStateToProps = (state) => ({
  navigation: getFooterNavigation(state),
});

export default connect(mapStateToProps)(Footer);
